import fulfill from '../../../fulfill';
import { SideEffectFunction } from '../../../sideEffects';
import { CORE_API_HOSTNAME } from '../../../env';
import { ActionTypes, CompleteVippsConnection, FetchCompleteVippsConnectionResponse, VippsApiError } from './actions';

const fetchCompleteVippsConnection: SideEffectFunction<
    CompleteVippsConnection,
    FetchCompleteVippsConnectionResponse
> = async action => {
    const result: FetchCompleteVippsConnectionResponse = await fulfill.post({
        accountId: action.payload.accountId,
        json: action.payload.data,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${
            action.payload.accountId
        }/management/settings/connections/vipps/${action.payload.userId}`,
        handlers: {
            202: () => ({
                type: ActionTypes.FetchCompleteVippsConnectionResponse,
                payload: {},
                meta: {
                    cause: action,
                },
            }),
            500: returnVippsApiError,
            501: returnVippsApiError,
            502: returnVippsApiError,
            503: returnVippsApiError,
            504: returnVippsApiError,
        },
    });
    return result;
};

const returnVippsApiError = (): VippsApiError => ({
    type: ActionTypes.CallbackError,
    payload: {},
});

const effects = {
    [ActionTypes.CompleteVippsConnection]: fetchCompleteVippsConnection,
};

export default effects;
